<template>
    <v-card>
        <v-card-text class="pb-1">
            <v-row>
                <v-col
                    class="px-0"
                    cols="3">
                    <date-range-field
                        class="mx-4"
                        v-model="pagination.dateRange"/>
                </v-col>
                <v-col
                    class="px-0"
                    cols="4">
                    <v-text-field
                        outlined
                        hide-details
                        height="40px"
                        append-icon="search"
                        v-model="pagination.search"
                        :placeholder="$t('placeholder.filterByCustomerNameAndCreatedBy')"/>
                </v-col>
                <v-col cols="2">
                    <v-select
                        outlined
                        hide-details
                        v-model="pagination.status"
                        append-icon="expand_more"
                        height="40px"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="statusList"/>
                </v-col>
                <v-col cols="3">
                    <v-btn
                        class="float-right"
                        color="primary"
                        @click="openCreateEventPanel">
                        {{ $t('button.createEvent') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <event-table
                :search="pagination.search"
                :items="events"
                :options="pagination"
                @edit="openEditEventPanel"
                @viewQr="openQRCodePanel"/>
        </v-card-text>

        <right-panel
            hideBottom
            ref="qrCodePanel"
            :title="$t('eventList.qrHeader')">
            <template v-slot:content="{ context }">
                <event-q-r-view
                    :event="context"/>
            </template>
        </right-panel>

        <right-panel
            ref="editEventPanel"
            :title="$t('eventList.editHeader')">
            <template v-slot:content="{ context }">
                <event-details-view
                    :event="context"/>
            </template>
            <template v-slot:bottom>
                <v-menu
                    top
                    offset-y
                    nudge-top="12px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            width="120px"
                            color="primary"
                            v-on="on"
                            v-bind="attrs">
                            <icon
                                class="mr-1"
                                value="hero_Trash"
                                size="18px"/>
                            {{ $t('button.delete') }}
                        </v-btn>
                    </template>
                    <v-card elevation="0">
                        <v-card-title class="error--text">
                            <icon
                                value="error_outline"
                                class="mr-2 error--text"/>
                            {{ $t('eventList.eventDetails.dialog.delete.header') }}
                        </v-card-title>
                        <v-card-text v-html="$t('eventList.eventDetails.dialog.delete.content')">
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                outlined
                                color="grey">
                                {{ $t('eventList.eventDetails.dialog.delete.cancel') }}
                            </v-btn>
                            <v-btn
                                color="error">
                                {{ $t('eventList.eventDetails.dialog.delete.confirm') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>

        <right-panel
            ref="createEventPanel"
            :title="$t('eventList.createHeader')">
            <template v-slot:content="{ context }">
                <event-details-view
                    create-mode
                    :event="context"/>
            </template>

            <template v-slot:bottom>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary">
                    {{ $t('button.create') }}
                </v-btn>
            </template>
        </right-panel>
    </v-card>
</template>

<script>
import EventTable from '@/components/tables/EventTable'
import EventDetailsView from '@/views/EventDetailsView'
import RightPanel from '@/components/panels/RightPanel'
import DateRangeField from '@/components/fields/DateRangeField'
import EventQRView from '@/views/EventQRView'

export default {
    name: 'EventList',

    components: {
        EventTable,
        EventQRView,
        RightPanel,
        EventDetailsView,
        DateRangeField
    },

    props: {
        events: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            statusList: [
                this.$constant.ALL_STATUS,
                this.$constant.ACTIVE_STATUS,
                this.$constant.INACTIVE_STATUS
            ]
        }
    },

    methods: {
        openEditEventPanel (eventItem) {
            this.$refs.editEventPanel.open(eventItem)
        },

        openCreateEventPanel () {
            this.$refs.createEventPanel.open({
                participantAmount: 0,
                teamAmount: 0,
                teamType: 'random',
                status: 'active'
            })
        },

        openQRCodePanel (eventItem) {
            this.$refs.qrCodePanel.open(eventItem)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-select {
    .v-select__selection {
        text-transform: capitalize;
    }
}
</style>
